import "./loan-sections.css";

const STEPS = [
  {
    n: "1",
    icon: "fa-file-lines",
    title: "Apply Online",
    text: "Fill in a simple form and submit your basic details.",
  },
  {
    n: "2",
    icon: "fa-sack-dollar",
    title: "Get Approved",
    text: "Our experts verify your details and get you the best offer.",
  },
  {
    n: "3",
    icon: "fa-arrows-rotate",
    title: "Get Disbursed",
    text: "Loan amount is disbursed quickly to your account.",
  },
];

export default function LoanProcess() {
  return (
    <section className="loan-process">
      <div className="loan-process-inner">
        <header className="loan-section-head">
          <p className="loan-eyebrow">SIMPLE 3-STEP LOAN PROCESS</p>
          <h2>Apply. Get Approved. Get Your Loan.</h2>
        </header>

        <div className="loan-process-track">
          <div className="loan-process-line" aria-hidden="true" />
          {STEPS.map((step) => (
            <div key={step.n} className="loan-process-step">
              <div className="loan-process-icon" aria-hidden="true">
                <i className={`fa-solid ${step.icon}`} />
              </div>
              <span className="loan-process-num">{step.n}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
